import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";

import ItemSimplesListagem from '../../components/listagem/ItemSimplesListagem';
import STRINGS from './../../data/language/language';
import Random from "../../utils/strings/Random";
import {FormDataToJson} from '../../utils/json/Json';
import Dialog from '../../components/alert/Dialog';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import PAGES from '../../config/Pages';
import MedidasForm from './MedidasForm';
import ONDE_TREINA from "../../data/Onde_treina";
import TIPOS_PLANILHA from "../../data/TiposPlanilha";
import DAYS from "../../data/Days";
import TEMPO_MUSCULACAO from "../../data/TempoMusculacao";
import ESTADOS from "../../data/Estados";
import Select from "../../components/form/Select";
import PageDados from './PageDados';
import PageAcesso from './PageAcesso';
import PageTreino from './PageTreino';
import PageEndereco from './PageEndereco';
import PagePagamentos from './PagePagamentos';

const URL_SAVE = WS.clientes.save;
const URL_CANCELAR = WS.clientes.cancelar;
const DADOS = 1;
const ACESSO = 2;
const TREINO = 3;
const ENDERECO = 4;
const PAGAMENTOS = 5;

class Page extends React.Component{
  constructor (props){
    super(props);

    this.state = {
      wrapper:Random(7),
      strings:STRINGS[window.LANGUAGE],
      detalhe: {
        id: props.detalhe.id
      },
      perfil: DADOS
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeData = this.changeData.bind(this);
    this.cancelarPlano = this.cancelarPlano.bind(this);
    this.gerarBoleto = this.gerarBoleto.bind(this);
    this.onGetHash = this.onGetHash.bind(this);
    this.onGetData = this.onGetData.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {

  }

  onGetHash(hash) {
    this.setState(
      {
        hashBoleto: hash
      }
    );
  }

  onGetData(data) {
    this.setState({
      detalhe: data.data
    });
  }

  gerarBoleto(e) {
    e.preventDefault();

    if(!this.state.hashBoleto){
      var msg = {
        title: 'Atenção',
        text: 'Dados necessários para gerar o boleto faltando, recarregue a página e aguarde um momento!'
      };
      Dialog.create(msg);

      return false;
    }

    const _self = this;
    const {
      atencao,
      salvoSucesso,
      erroSalvarBloco,
      preenchaCamposAsterisco,
      escolhaOsExercicios,
      erroSalvar
    }
    = this.state.strings;
    const id = this.props.detalhe.id;

    //----------------
    Requisitions({
      url: WS.clientes.gerarBoleto,
      data: { id, ps_hash: this.state.hashBoleto },
      sucess:function(data){

        if(data.status){
          var msg = {
            type: Dialog.CONFIRM,
            title: 'Atenção',
            text: 'Boleto gerado com sucesso',
            onCancel: () => { Dialog.destroy() },
            onSubmit: () => {
              var win = window.open(data.url, '_blank');
              win.focus();
            },
            txtCancel: 'Fechar',
            txtOk: 'Visualizar',
          };
          Dialog.create(msg);
        }else{
          var msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: 'Ocorreu um erro ao gerar o boleto'
        });
      }
    });
  }

  getPage() {
    switch(this.state.perfil){
      case DADOS:
        return <PageDados data={this.state.detalhe} onGetHash={this.onGetHash} onGetData={this.onGetData} />;
      break;
      case ACESSO:
        return <PageAcesso data={this.state.detalhe}  />;
      break;
      case TREINO:
        return <PageTreino data={this.state.detalhe}  />;
      break;
      case ENDERECO:
        return <PageEndereco data={this.state.detalhe}  />
      break;
      case PAGAMENTOS:
        return <PagePagamentos data={this.state.detalhe}  />
      break;
    }
  }

  cancelarPlano(e){
    e.preventDefault();

    const history = this.props.history;

    const _self = this;
    const {
      atencao,
      salvoSucesso,
      erroSalvarBloco,
      preenchaCamposAsterisco,
      escolhaOsExercicios,
      erroSalvar
    }
    = this.state.strings;
    const {id} = this.state.detalhe;

    //----------------
    Requisitions({
      url: URL_CANCELAR,
      data: {id, motivo: ''},
      sucess:function(data){
        var msg;
        _self.props.modal.close();
        history.push(PAGES.clientes);
        msg = {
          title: atencao,
          text: data.msg
        };
        Dialog.create(msg);
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroSalvar
        });
      }
    });
  }

  changeData(e,tipo) {
    this.setState({
      perfil: tipo
    });

    e.preventDefault();
  }

  handleSubmit (e){
    e.preventDefault();

    const history = this.props.history;

    const _self = this;
    const {
      atencao,
      salvoSucesso,
      erroSalvarBloco,
      preenchaCamposAsterisco,
      escolhaOsExercicios,
      erroSalvar
    }
    = this.state.strings;

    const formData = new FormData(e.target);

    //transforma o formData em um json
    var object = FormDataToJson(formData);

    //----------------

    Requisitions({
      url:URL_SAVE,
      data: object,
      sucess:function(data){
        var msg;
        _self.props.modal.close();
        history.push(PAGES.clientes);
        msg = {
          title: atencao,
          text: data.msg
        };
        Dialog.create(msg);
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroSalvar
        });
      }
    });
  }

  getPagamentoView() {
    const data = this.state.detalhe.pagamento;
    return (
      <div className="pure-u-1">

        <div className='box-dados-cliente__item_wrapper'>
          <div className='box-dados-cliente__item box-dados-cliente__item--title'><strong>Dados do pagamento:</strong></div>
          <div className='box-dados-cliente__item'><strong>Data pagamento: </strong>{data.data}</div>
          <div className='box-dados-cliente__item'><strong>Código de autorização: </strong>{data.authorization_code}</div>
          <div className='box-dados-cliente__item'><strong>Payment id: </strong>{data.payment_id}</div>
          <div className='box-dados-cliente__item'><strong>TID: </strong>{data.tid}</div>
        </div>
      </div>
    );
  }

  render (){
    let wrapper = this.state.isLoading ? null : this.getPage();
    const str = this.state.strings;
    const id = this.props.detalhe ? <input type='hidden' name='id' value={this.props.detalhe.id} />   : '';
    const data = this.state.detalhe ? this.state.detalhe : {};
    const data_medidas = this.props.detalhe ? this.props.detalhe : {};
    const medidas = data_medidas.medidas.map((value, i) =>
        <MedidasForm key={i} data={value} strings={str} />
      );

    const btCancelar = data.cancelado ?
    (<span className='cliente-cancelado-txt'>{str.clienteCancelado}</span>) :
    (<a href='#' className='bt-cancelar-plano' onClick={this.cancelarPlano}>Cancelar plano</a>);

    let btBoleto = null;
    if(data.cancelado){

    }else{
      btBoleto = data.tipo_adesao === 'boleto' ? (<a href='#' onClick={this.gerarBoleto} className='bt-gerar-boleto'>Gerar novo boleto</a>) : null;
    }

    let situacaoCli;

    switch(data.situacao){
      case 'teste':
      case 'Teste':
        situacaoCli = 'cliente-situacao-teste';
      break;
      case 'cancelado':
      case 'Cancelado':
        situacaoCli = 'cliente-situacao-cancelado';
      break;
      case 'ativo':
      case 'Ativo':
        situacaoCli = 'cliente-situacao-ativo';
      break;
    }

    const planoDados = data.pagamento ? this.getPagamentoView() : null;


    return (
      <div>
        <MainTitle
          title="Dados do cliente"
        />
      <div className="" >
          {id}
          <div className="pure-u-1-5">
            <div className='foto-user'>
              <div className='box-medidas-usuario box-input--border'>
                <div className='box-input--inner'>
                  <img src={data.foto} width='100' />
                  <input type='hidden' name='foto' value={data.foto} />
                </div>
              </div>
            </div>
          </div>
          <div className="pure-u-4-5">
            <div className='box-dados-cliente'>
              <div className='pure-u-1-2'>
                <div className='box-dados-cliente__item'><strong>Validade:</strong> {data.validade}</div>
                <div className='box-dados-cliente__item'><strong>Tipo de pagamento:</strong> {data.tipo_adesao}</div>
                <div className='box-dados-cliente__item'><strong>Situação do cliente:</strong> <span className={situacaoCli}>{data.situacao}</span></div>
                <div>
                  {btBoleto}
                </div>
              </div>
              <div className='pure-u-1-2'>
                <div className='box-cancelar'>
                  {btCancelar}
                </div>
              </div>
            </div>
          </div>
          {planoDados}
          <div className='box-perfil-user'>
            <div className='wrapper-buttons-mensagens'>
              <a
                onClick={(e) => this.changeData(e, DADOS)}
                className={`${(this.state.perfil === DADOS ? 'ativo' : '')} button-mensagem`}
                href="#"
              >Dados do cliente</a>
              <a
                onClick={(e) => this.changeData(e, ACESSO)}
                className={`${(this.state.perfil === ACESSO ? 'ativo' : '')} button-mensagem`}
                href="#"
              >Dados de acesso</a>
              <a
                onClick={(e) => this.changeData(e, TREINO)}
                className={`${(this.state.perfil === TREINO ? 'ativo' : '')} button-mensagem`}
                href="#"
              >Mudar treino</a>
              <a
                onClick={(e) => this.changeData(e, ENDERECO)}
                className={`${(this.state.perfil === ENDERECO ? 'ativo' : '')} button-mensagem`}
                href="#"
              >Endereço</a>
              <a
                onClick={(e) => this.changeData(e, PAGAMENTOS)}
                className={`${(this.state.pagamentos === PAGAMENTOS ? 'ativo' : '')} button-mensagem`}
                href="#"
              >Pagamentos</a>
            </div>
            <div className="listagem listagem-mensagens">
              {wrapper}
            </div>
            <div className='clear'></div>
          </div>
          <br />
          <br />
          <div className='box-input'>
            <div className="box-input--title">{str.fieldMedidasUsuarios}</div>
            <div className='box-medidas-usuario box-input--border'>
              <div className='box-input--inner'>
                {medidas}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/clientes/Page.js